// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type TopicRelatedInstancesQueryVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type TopicRelatedInstancesQuery = (
  { __typename?: 'Query' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & TopicRelatedInstancesFragment
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export type TopicRelatedInstancesFragment = (
  { __typename?: 'TopicModelAsEditor' }
  & { relatedCampaignsByFilters: Array<(
    { __typename?: 'CampaignModelAsAdminQueries' }
    & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )>, relatedCampaignsByActions: Array<(
    { __typename?: 'CampaignModelAsAdminQueries' }
    & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )>, relatedCertifications: Array<(
    { __typename?: 'CertificationModelAsAdmin' }
    & Pick<PrivateSchemaTypes.CertificationModelAsAdmin, 'id' | 'name'>
    & { author?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    )> }
  )>, relatedPathways: Array<(
    { __typename?: 'PathwayModelAsAdmin' }
    & Pick<PrivateSchemaTypes.PathwayModelAsAdmin, 'id' | 'title'>
    & { owner: (
      { __typename?: 'UserModel' }
      & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity'>
    ) }
  )> }
);

export type ArchiveTopicMutationVariables = PrivateSchemaTypes.Exact<{
  topicId: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ArchiveTopicMutation = (
  { __typename?: 'Mutation' }
  & { topic?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'TopicModelAsEditor' }
    & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    & { archive: (
      { __typename?: 'TopicModelAsEditor' }
      & Pick<PrivateSchemaTypes.TopicModelAsEditor, 'id'>
    ) }
  ) | (
    { __typename?: 'TopicModelAsMember' }
    & Pick<PrivateSchemaTypes.TopicModelAsMember, 'id'>
  )> }
);

export const TopicRelatedInstancesFragmentDoc = gql`
    fragment topicRelatedInstances on TopicModelAsEditor {
  relatedCampaignsByFilters {
    id
    name
    author {
      id
      userIdentity
    }
  }
  relatedCampaignsByActions {
    id
    name
    author {
      id
      userIdentity
    }
  }
  relatedCertifications {
    id
    name
    author {
      id
      userIdentity
    }
  }
  relatedPathways {
    id
    title
    owner {
      id
      userIdentity
    }
  }
}
    `;
export const TopicRelatedInstancesDocument = gql`
    query topicRelatedInstances($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ...topicRelatedInstances
  }
}
    ${TopicRelatedInstancesFragmentDoc}`;

/**
 * __useTopicRelatedInstancesQuery__
 *
 * To run a query within a React component, call `useTopicRelatedInstancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicRelatedInstancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicRelatedInstancesQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useTopicRelatedInstancesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TopicRelatedInstancesQuery, TopicRelatedInstancesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TopicRelatedInstancesQuery, TopicRelatedInstancesQueryVariables>(TopicRelatedInstancesDocument, options);
      }
export function useTopicRelatedInstancesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TopicRelatedInstancesQuery, TopicRelatedInstancesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TopicRelatedInstancesQuery, TopicRelatedInstancesQueryVariables>(TopicRelatedInstancesDocument, options);
        }
export type TopicRelatedInstancesQueryHookResult = ReturnType<typeof useTopicRelatedInstancesQuery>;
export type TopicRelatedInstancesLazyQueryHookResult = ReturnType<typeof useTopicRelatedInstancesLazyQuery>;
export type TopicRelatedInstancesQueryResult = Apollo.QueryResult<TopicRelatedInstancesQuery, TopicRelatedInstancesQueryVariables>;
export const ArchiveTopicDocument = gql`
    mutation archiveTopic($topicId: PositiveInt!) {
  topic(id: $topicId) {
    id
    ... on TopicModelAsEditor {
      archive {
        id
      }
    }
  }
}
    `;
export type ArchiveTopicMutationFn = Apollo.MutationFunction<ArchiveTopicMutation, ArchiveTopicMutationVariables>;

/**
 * __useArchiveTopicMutation__
 *
 * To run a mutation, you first call `useArchiveTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTopicMutation, { data, loading, error }] = useArchiveTopicMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *   },
 * });
 */
export function useArchiveTopicMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveTopicMutation, ArchiveTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveTopicMutation, ArchiveTopicMutationVariables>(ArchiveTopicDocument, options);
      }
export type ArchiveTopicMutationHookResult = ReturnType<typeof useArchiveTopicMutation>;
export type ArchiveTopicMutationResult = Apollo.MutationResult<ArchiveTopicMutation>;
export type ArchiveTopicMutationOptions = Apollo.BaseMutationOptions<ArchiveTopicMutation, ArchiveTopicMutationVariables>;